export const redirectIfNotLoggedIn = actionIfLoggedIn => (dispatch, getState) => {
    if (actionIfLoggedIn) {
        actionIfLoggedIn();
    }

    return true;
};
